import { IServiceResponse, ServiceResponse } from '@/core/model/rest/IServiceResponse';
import { INotificacionErrorUI, NotificacionErrorUI } from '@/core/model/notificacion-ui/INotificacionUI';
import axios, { AxiosInstance} from 'axios'
import { eTiposClienteRest } from '@/core/model/GloblasEnum';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store'
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import CService from '@/core/services/base/CService';
import { useMainStore } from '@/core/stores/main-store';
/*interface IRequestParam
{  
  Type:number,
  UsuarioId:string,
  
}*/
export default class ClientHttpService
{
  protected urlBase: string|null = null;
  protected httpClient: AxiosInstance;
  protected requestError: INotificacionErrorUI|null = null;
  protected requestResponse: IServiceResponse|any = null;
  //protected requestParam: IRequestParam = {Type:0,UsuarioId:""};
  public get HasErrorRequest () { return this.requestError != null;}
  public get RequestError () { return this.requestError;}
  public get RequestResponse ():any { return this.requestResponse;}
 /* public set SetSesion(sesion:ISesionApp)
  { 
    this.requestParam.Type = sesion.Type;
    this.requestParam.UsuarioId = sesion.getId();

  }*/
  protected SetErrorRequest = (error: any) =>
  {    
    this.requestError = new NotificacionErrorUI(error);
  }  
  constructor(baseUrl?: string)
  {             
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;    
    this.urlBase = baseUrl? baseUrl:null;
    this.httpClient = axios.create();        
    this.httpClient.interceptors.response.use(function (response)
    {
      return response;
    },
    function (error)
    {   
      self.SetErrorRequest(error);        
      return Promise.reject(error);
    });          
  }  
  public HasBaseUrl():boolean
  {      
    return this.urlBase? true:false;
  }
  public GetBaseUrl()
  {
    return this.urlBase;      
  }
  public SetBaseUrl(url: string)
  {
    this.urlBase = url;      
  }    
  protected Combine(url: string):string
  {           
      let newurl = '';
      newurl = this.urlBase? (this.urlBase + (this.urlBase.endsWith('/') ? '' : '/' ) + url) : '';    
      return newurl;
  }
  protected async GetSesion(): Promise<ISesionApp|null>
  {
    const service = useServicesFactoryStore().getLoginService; 
    const sesion = service? await service.getSession():null;
    return sesion;
  }
  protected NewRequest()
  {
    this.requestError = null;
    this.requestResponse = null;    
  }     
  protected GetCService(): CService
  {
    return (useServicesFactoryStore().getCService as CService);     
  } 
  protected getAppLanguage():string
  {
    return useMainStore().getAppLanguage;
  }   
  protected async BuildConfig(verb: string, url: string,data?: any, transforn?:any,responseType?:any): Promise<object>
  {
    this.NewRequest();
    const Sesion :ISesionApp|null = await this.GetSesion();    
    const config = {
        method: verb,        
        url: this.Combine(url), 
        responseType: responseType? responseType:null,        
        headers:{}        
    };
    const lang = this.getAppLanguage();    
    const headers = {'ia-TipoClienteREST':eTiposClienteRest.WebERP,
                     'accept-language': lang? lang : 'es-MX',
                     'Content-Type': 'application/json',
                     'accept':'application/json'}
    if (Sesion)
    {      
      config.headers =  {...headers,                                                  
                        'ia-TypeSession':Sesion.Type,
                        'ia-IdUsuario': Sesion.getId(),                                             
                         'Authorization': `Bearer ${Sesion.Token}`,
                         'ia-TipoClienteREST':eTiposClienteRest.WebERP};      
    }    
    if(transforn)
    {            
      if(!data)
      {
      const config2={...config,transformResponse : [(data:any)=> { return this.CustomTransform(data,transforn);}]};      
      return config2;
      }
      else
      {
        const config2={...config,data,transformResponse : [(data:any)=> { return this.CustomTransform(data,transforn);}]};      
        return config2;
      }
    } 
    else
    {
      if(data)
      {
        const config2={...config,data};
        return config2;
      }
    }  
    
    
    return config;
  }
  protected CustomTransform(data: any,transforn:any)
  {      
    const obj = this.ResponseToJson(data);   
    const evalResp = this.EvalResponse(obj);
    this.requestResponse = new ServiceResponse(evalResp);    
    this.requestResponse.Response = null;
    return transforn(evalResp? evalResp.Response:data);
  }
  protected ResponseToJson(data: any): any
  {
    let resp = null;
    try
    {
      resp = JSON.parse(data);
    }
    catch(e)
    {      
      resp = null;
    }
    return resp;
  } 
  public async Get(url: string,fnOnResponse?:any, transform?: any,responseType?:any):Promise<any>
  {   
    const config = await this.BuildConfig('GET',url,null,transform,responseType);
    return this.httpClient(config).then(r => 
      {
        if(!transform)
        {
          this.requestResponse = this.EvalResponse(r? r.data:null);
        }  
        //executes when no error
        if(fnOnResponse)
        {
          fnOnResponse(r);
        }
        return r? r.data:null;
      })
    ;
  }
  public async Post(url: string,data: any,fnOnResponse?:any, transform?: any,responseType?:any):Promise<any>
  {       
    const config = await this.BuildConfig('POST',url,data,transform,responseType);    
    return this.httpClient(config).then(r => 
      {        
        if(!transform)
        {
          this.requestResponse = this.EvalResponse(r? r.data:null);
        }  
        //executes when no error
        if(fnOnResponse)
        {          
          fnOnResponse(r);
        }
        return r? r.data:null;
      })
    ;
  }
  protected EvalResponse(r:any):IServiceResponse|undefined
  {    
    if(r)
    {      
      const response:IServiceResponse = new ServiceResponse(r);
      return response? response:r;
    }
    else
    {
      return undefined;
    }
  }  
}